const SelectionScreenStatus = {
   GameSelection: "GameSelection",
   WaitingGameToStart: "WaitingGameToStart",
   Countdown: "Countdown",
};
const CountDownDurationInMiliseconds = 5000;

export { SelectionScreenStatus, CountDownDurationInMiliseconds };
